import {LogicalEventsState} from './states/logical-events.state';
import {LogicalMessagesState} from './states/messages-catalog.state';
import {MultiEventState} from './states/multi-event.state';

export const logicalEventsState = [
    LogicalEventsState,
    LogicalMessagesState,
    MultiEventState
];
